import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import classNames from 'classnames';

import { ModalHOC } from 'common/HOCs/ModalHOC';
import { NoItemsPanel } from 'common/components';
import { taggedStylesToString, withTheme } from 'common/styling/theme';

import FormFieldsComposer from '../FormFieldsComposer';

import { getDynamicStyles, staticStyles } from './style';

class MultiArrayField extends Component {
  // removeField = index => {
  //   const { showModal, fields } = this.props;
  //
  //   showModal({
  //     caption: { id: 'confirmOfRemoval' },
  //     content: {
  //       id: 'confirmDeleteArrayField',
  //     },
  //     actionButton: {
  //       textId: 'doRemove',
  //       type: 'error',
  //       handler: () => fields.remove(index),
  //     },
  //     cancelButton: {
  //       textId: 'justCancel',
  //     },
  //   });
  // };

  componentDidMount() {
    const { fields } = this.props;

    // 如果没有数据，添加一组默认数据（用于默认展示一条数据）
    if (!fields.length) {
      fields.push({});
    }
  }

  onDragEnd = result => {
    const { fields } = this.props;

    // dropped outside the list
    if (!result.destination) {
      return fields;
    }

    const startIndex = result.source.index;
    const endIndex = result.destination.index;
    const [removed] = fields.getAll().splice(startIndex, 1);

    fields.splice(endIndex, 0, removed);
  };

  render() {
    const {
      schema,
      fields,
      meta: { error, touched },
      formName,
      arraysName,
      submitting,
      theme,
    } = this.props;

    const style = taggedStylesToString(staticStyles);
    const dynamicStyles = Object.keys(theme).length ? taggedStylesToString(getDynamicStyles(theme)) : ` `;

    // const formError = !pristine && error;
    const isDragDisabled = !schema.ordering || fields.length === 1;
    const isFormError = typeof error === 'object';
    // 检查是否有 required 错误（字符串类型的错误）
    const hasRequiredError = touched && error && typeof error === 'string';

    return (
      <div className="FieldArray" id={arraysName}>
        <div className="FieldArray__top-line">
          <div className="FieldArray__title">
            <FormattedMessage id={schema.title}>{txt => <h2>{txt}</h2>}</FormattedMessage>
          </div>
        </div>
        {hasRequiredError && (
          <div className="FieldArray__error">
            <FormattedMessage id={error}>{txt => <span className="ArrayField__error">{txt}</span>}</FormattedMessage>
          </div>
        )}

        {fields.length ? (
          <DragDropContext onDragEnd={this.onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className={classNames('FieldArray__isDragging-inner', { isDraggingOver: snapshot.isDraggingOver })}>
                  {fields.map((item, index) => (
                    <Draggable
                      key={`${index}_${fields.length}`}
                      draggableId={item}
                      index={index}
                      isDragDisabled={isDragDisabled}>
                      {(provided, snapshot) => (
                        <div
                          className={classNames('FieldArray__item-inner', {
                            FieldArray__notDraggable: !schema.ordering,
                            FieldArray__isDraggable: snapshot.isDragging,
                            FieldArray__item_error: isFormError && error[index],
                          })}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={provided.draggableProps.style}>
                          <div className="FieldArray__item">
                            <p className="FieldArray__item-number">{index + 1}</p>
                            <FormFieldsComposer
                              name={`${item}`}
                              schema={schema.items}
                              formName={formName}
                              submitting={submitting}
                            />
                            {isFormError && error[index] && (
                              <FormattedMessage id={error[index]}>
                                {txt => <span className="ArrayField__item-error">{txt}</span>}
                              </FormattedMessage>
                            )}
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        ) : (
          <NoItemsPanel
            captionSlug={schema.title}
            descriptionSlug={schema.description}
            className="FieldArray__no-items"
            isError={!!error}
          />
        )}

        <style>{style}</style>
        <style>{dynamicStyles}</style>
      </div>
    );
  }
}

MultiArrayField.propTypes = {
  schema: PropTypes.object.isRequired,
  formName: PropTypes.string.isRequired,
  showModal: PropTypes.func.isRequired,
  meta: PropTypes.object.isRequired,
  fields: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  arraysName: PropTypes.string.isRequired,
  submitting: PropTypes.bool,
  theme: PropTypes.object,
};

MultiArrayField.defaultProps = {
  fields: {},
  submitting: false,
  theme: {},
};

const ThemedArrayField = withTheme()(ModalHOC(MultiArrayField));

export default ThemedArrayField;
export { MultiArrayField };
